import { render, staticRenderFns } from "./WorkLayout.vue?vue&type=template&id=0f49777e&"
import script from "./WorkLayout.vue?vue&type=script&lang=js&"
export * from "./WorkLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports